import { InjectionToken, computed, inject } from '@angular/core';
import { ICmsConfigResource } from '@icms/core/resource/config/icms-config.resource';
import { patchState, signalStoreFeature, withComputed, withHooks, withMethods, withState } from '@ngrx/signals';
import { AdvancedCommerce } from '../../advanced-commerce.namespace';
import { AdvancedCommerceStore } from '../advanced-commerce-store.namespace';

const initialState: AdvancedCommerceStore.Config.State = {
    config: undefined
};

export const ADVANCED_COMMERCE_CONFIG_STATE = new InjectionToken<AdvancedCommerceStore.Config.State>('ADVANCED_COMMERCE_CONFIG_STATE', {
    factory: () => initialState
});

/**
 * Advanced Commerce Config Store
 *
 * @link https://ngrx.io/guide/signals/signal-store
 */
export function withConfig() {
    return signalStoreFeature(
        withState(() => inject(ADVANCED_COMMERCE_CONFIG_STATE)),
        withComputed(store => ({
            token: computed(() => {
                const config = store.config();

                if (config !== undefined && config.apiKey && config.apiSecret) {
                    return btoa(`${config.apiKey}:${config.apiSecret}`);
                }

                return null;
            })
        })),
        withMethods((store, configResource = inject(ICmsConfigResource)) => ({
            async loadConfig(): Promise<AdvancedCommerceStore.Config.Config> {
                return new Promise(async resolve => {
                    const data = (await configResource.retrieve(
                        {
                            bareUrl: AdvancedCommerce.ID
                        },
                        undefined
                    )) as AdvancedCommerce.Config.CmsConfig;

                    if (data) {
                        patchState(store, {
                            config: data?.data?.content
                        });

                        resolve(data?.data?.content);
                    } else {
                        resolve(undefined);
                    }
                });
            }
        })),
        withHooks(store => {
            return {
                onInit() {
                    store.loadConfig();
                }
            };
        })
    );
}
